import { faGear } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "bootstrap/dist/css/bootstrap.min.css";
import { stat } from "fs";
import * as React from "react";
import { store } from "react-notifications-component";
import "react-notifications-component/dist/theme.css";
import { Col, Container, Row } from "reactstrap";
import SettingList from "./settingList";

class SettingPageComponent extends React.Component {
	state = {
		page: "",
		id: -1,
		title: "",
	};
	constructor(props: any) {
		super(props);
		this.state = {
			page: "",
			id: -1,
			title: "",
		};
		this.handleCallbackMethod = this.handleCallbackMethod.bind(this);
	}

	componentDidMount() {
		var codestr = new URLSearchParams(window.location.search).get("code");
		var codeValue = codestr == null ? "" : codestr;
		this.setState({
			...stat,
			code: codeValue,
		});

		var alertMessage = window.localStorage.getItem("alertMessage");
		if (alertMessage && alertMessage != "") {
			store.addNotification({
				title: "Success!",
				message: alertMessage,
				type: "success",
				insert: "top",
				container: "top-right",
				animationIn: ["animate__animated", "animate__fadeIn"],
				animationOut: ["animate__animated", "animate__fadeOut"],
				dismiss: {
					duration: 5000,
					onScreen: true,
				},
			});
			window.localStorage.setItem("alertMessage", "");
		}

		document.title = "Settings - Daily Audio Bible Administration";
	}

	handleCallbackMethod(value) {
		this.setState({ title: value });
	}

	render() {
		const { title } = this.state;
		return (
			<div>
				<Container>
					<Row>
						<Col lg="12">
							{this.state.page == "" && (
								<div>
									<h2>
										<FontAwesomeIcon icon={faGear} />
										<span data-testid="settingPageTitle">
											{" "}
											Settings
										</span>
									</h2>
									<hr />
									<SettingList />
								</div>
							)}
						</Col>
						<Col />
					</Row>
				</Container>
			</div>
		);
	}
}

export default SettingPageComponent;
